var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-score"},[_c('p',[_vm._v(_vm._s(_vm.$translate('score')))]),_c('p',{staticClass:"app-score__current-points",domProps:{"innerHTML":_vm._s(_vm.$store.state.score)}})])}
var staticRenderFns = []

export { render, staticRenderFns }